'use client'

import { useEffect } from 'react'

export function ServiceWorkerRegister() {
  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      !('serviceWorker' in navigator)
    ) {
      return
    }

    navigator.serviceWorker
      .register('/service-worker.js', {
        scope: '/',
      })
      .catch((error) => {
        console.error(
          '[pwa] service worker registration failed',
          error
        )
      })
  }, [])

  return null
}